import {
  Component, OnInit,
  ViewContainerRef,
  ElementRef, ViewChild
} from '@angular/core';
import { AppService } from '../../../../../app.service';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem, EquipmentDetailsParams } from '../../../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../../../setup-equipment/setup-equipment.service';
import { SetupImplementService } from './../../setup-implement.service';
import { EquipmentService } from '../../../services/equipment.service';
import {
  TemplateViewModel,
  GenericIdName,
  ImplementDetails,
  MeasurementPointDetails,
  ObservationPointDetails,
  SaveImplementImageParams,
  SchematicDataVM,
  ComponentVM,
  ApplySelectionData,
  SaveImplementDetailParams,
  SaveMeasurementPointParams,
  SaveObservationPointParams,
  SaveComponentParams,
  SetupImplementPageConstants,
  SetupImplementErrorCodes,
  SaveModeltParams,
  SchematicImagesVM,
  saveNewImplementTypeVM,
  ValidationErrorStatus,
  SchematicUploadParams,
  SaveQuestionImageParams,
  ObservationPointVMEdit,
  observationListVM,
  UpdateQuestion,
  DeleteQuestion
} from './../../setup-implement.model';
import { ModelSelected } from '../../../entities/global/model';
import { NewImplementTemplate } from '../../../entities/implement-template.model';
import { DomSanitizer } from '@angular/platform-browser';
import 'rxjs/add/observable/forkJoin';
import { UpdateObservationPointModal } from '../../../add-observation-point/add-observation-point-modal';
import { EquipmentDetailsService } from '../../../equipment-details/equipment-details.service';
import { FamilyList, ObservationPointVM } from '../../../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../../favourite-dialog/favourite-dialog.service';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { NotificationsService } from 'angular2-notifications';
import { SchematicViewService } from '../../../schematic-view/schematic-view.service';
import { SchemanticOpPopupEditComponent } from '../../../schemantic-op-popup-edit/schemantic-op-popup-edit.component';
import { componentListsVM } from '../../../equipment-details/equipment-details.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ViewPhotoComponent } from '../../../../interpretation/components/view-photo/view-photo.component';
import { CommentPopupComponent } from '../../../inspections/new-inspection/implement-inspection-section/components/observation-comments/comment-popup/comment-popup.component';
import { ConfirmationBoxComponent } from '../../../../../shared/confirmation-box/confirmation-box.component';
import { AddCrackObsPointDialogComponent } from '../../../add-crack-obs-point-dialog/add-crack-obs-point-dialog.component';
import { heicTo } from 'heic-to';

@Component({
  selector: 'app-implement-obspoint-setup',
  templateUrl: './implement-obspoint-setup.component.html',
  styleUrls: ['./implement-obspoint-setup.component.scss']
})
export class ImplementObspointSetupComponent implements OnInit {
  private _subscriptions: Subscription[] = [];
  private _equipmentId: number;
  private _implementId: number;
  oldGetUrl: string;
  setupComplete: boolean = false;
  isLinear: boolean = true;
  currentStep: number = 0;
  IsTemplate: boolean = false;
  // Image uploaders
  @ViewChild('uploadImplementImage') ImplementImageUpload: ElementRef;
  @ViewChild('uploadSchematicImage') SchematicImageUpload: ElementRef;

  // Page constants
  pageConstants: SetupImplementPageConstants = new SetupImplementPageConstants();

  // Error codes
  pageErrors: SetupImplementErrorCodes = new SetupImplementErrorCodes();

  // Radio buttons
  newOrExistingOption: string = this.pageConstants.IMPLEMENT_SETUP_NEW;
  equipmentOrInventory: string = this.pageConstants.SETUP_ON_EQUIPMENT;

  // Models
  modelList_: GenericIdName[] = [];
  modelList: ModelSelected[] = [];
  modelListFiltered: ModelSelected[];
  modelListFilter: string;
  selectedModels: number[] = [];
  implementTemplateDetails: NewImplementTemplate;

  // Component Types
  componentList: ComponentVM[] = [];
  componentListFiltered: ComponentVM[];
  componentListFilter: string;
  selectedComponentsList: ComponentVM[] = [];
  newComponentName: string;
  newComponentMakeId: number;
  newComponentPartNo: string;
  newComponentId: number = 1;
  newComponentCritical: boolean = true;
  isGETCritical: boolean
  cbAllComponentsSelect: boolean = true;
  cbAllObservationSelect: boolean = false;
  newComponentTypeId: number;
  newcompBudgetLife: number = 2000;

  // Save component - unsaved changes warning.
  unsavedChanges_ComponentSetup: boolean = false;
  unsavedChanges_OPSetup: boolean = false;
  unsavedChanges_ModelSetup: boolean = false;
  loading: boolean = false;
  // Observation Point Types
  observationPointTypes: GenericIdName[] = [];
  observationPointListFilter: string;

  // Model loading Finished
  modelsLoaded: boolean = false;

  // Filter by selected or unselected.
  hideSelectedModels: boolean = false;
  hideUnselectedModels: boolean = false;
  hideSelectedMPs: boolean = false;
  hideUnselectedMPs: boolean = false;
  hideSelectedOPs: boolean = false;
  hideUnselectedOPs: boolean = false;

  // Step 1
  customerList: CustomerSelectItem[] = [];
  jobsiteList: JobsiteSelectItem[] = [];
  equipmentList: EquipmentSelectItem[] = [];
  NewimplementType: string
  NewImplementImage: string = ""
  isNewImplement: boolean = false
  // User selections in input boxes
  selectedCustomer: number = 0;
  selectedJobsite: number = 0;
  selectedEquipment: number = 0;
  selectedMake: number = 0;
  selectedImplementType: number = 0;
  selectedImplement: number = 0;
  selectedSchematic: SchematicDataVM;
  selectedSchematicEdit: ObservationPointVMEdit
  selectedSchematicEdit_: SchematicDataVM[]
  NewSchematicId: number = 1;
  budgetHrs: number;
  bcmHrs: number;
  tonHrs: number;

  purchaseCost: number;
  // Preserve implement id, which gets lost after navigating away from the tab.
  attachedImplementSelected: number = this.selectedImplement;

  // Preserve previously selected implement type.
  prevSelectedImplementType: number = 0;

  // Step 2
  implementList: GenericIdName[] = [];
  implementTypeList: TemplateViewModel[] = [];
  makeList: GenericIdName[] = [];
  serialNumber: string = '';
  canChangeHoursAndDate: boolean = true;
  dateOfReading: Date = new Date();
  implementHours: number = 0;
  equipmentSMU: number = 0;
  Additional_serial_num: string = null;
  bucketCapacity: number;
  selectedGETType: number;
  implementImage: string = '';
  schematicList: SchematicDataVM[] = [];
  FilteredschematicList: SchematicDataVM[] = [];


  // Step 3
  //componentList: MeasurementPointDetails[] = [];
  observationLists: observationListVM[] = [];
  observationListsForCrack: observationListVM[] = [];
  observationPoints: ObservationPointDetails[] = [];
  observationListFiltered: ObservationPointDetails[] = []
  selectedObservationList: ObservationPointDetails[] = [];

  newOPName: string = "";
  newOPObservationListId: number = 0;
  newOPLimitNew: number = 0;
  newOPLimitScrap: number = 0;

  observationListFilter: string;
  observationListAfterChanages: ObservationPointDetails[]
  isvalidStep3: boolean = true


  // Right-click Context Menu
  showContextMenu: boolean = false;
  contextMenuX: string = "100px";
  contextMenuY: string = "100px";
  selectionData: ApplySelectionData = new ApplySelectionData();

  // Highlight for vacant or all cells, for the right-click context menu.
  showVacantCells: boolean = false;
  showAllCells: boolean = false;

  // Schematic window.
  showSchematic: boolean = false;
  schematicPositionX: number;
  schematicPositionY: number;
  draggableSchematicTitle: string = "Schematic";
  showObservation: boolean = true;

  // Pre-populate Make for Measurement Points of new Implement with the Equipment / Implement Make.
  prepopulateMake: number = 0;

  // Mouse events for draggable schematic window.
  isMouseDown: boolean = false;
  prevMouseX: number;
  prevMouseY: number;

  // Mouse-over highlight components and observation points.
  mouseoverMPId: number = 0;
  mouseoverOPId: number = 0;

  // Mouse-over highlight implement type replicate icon
  mouseoverITReplicate: boolean = false;

  observationListId: any;

  //tab3validation variables
  observationPointsOld: ObservationPointDetails[]
  cbApplyToAll: boolean = false
  cbApplyToOne: boolean = true
  AllChecked
  OneChecked
  public selectedIds: any
  public selectedId: any
  public array: any
  public haschanges: Boolean
  onlyInA: any

  //getSchematic Image name
  selectedSechamnticImage: File
  SelectedschematicImageList: SchematicImagesVM = new SchematicImagesVM();
  Imagelist: SchematicDataVM[] = []

  equipmentDetails: EquipmentDetailsParams;

  componentTypeList: GenericIdName[] = [];

  //tab4
  selectedMakeList: number[] = [];
  familyList: FamilyList[] = [];
  selectedFamilyList: number[] = [];

  selectedFamily: number[] = [];
  selectedMakes: number[] = [];
  target: any[] = [];
  source: any[] = [];
  showObservationLists: boolean;

  getComponents: any;
  componentId: number;
  selectedQDesc: string = '';
  showPopup: boolean = false;
  selectedQImage: string = '';
  isNewSelectedQImage: boolean = false;
  observationListForCrackObs: observationListVM[] = [];
  constructor(private _appService: AppService,
    private _setupEquipmentService: GETSetupEquipmentService,
    private _implementService: SetupImplementService,
    private _route: ActivatedRoute, private _router: Router,
    private _sanitizer: DomSanitizer, private _snackBar: MatSnackBar,
    private _equipmentService: EquipmentService,
    public dialog: MatDialog, private toastr: NotificationsService,
    vcr: ViewContainerRef,
    public _equipmentDetailsService: EquipmentDetailsService,
    public _favouriteDialogService: FavouriteDialogService, public _dualList: AngularDualListBoxModule,
    public SchematicViewService_: SchematicViewService) {


  }

  ismodified: boolean = false;
  title: string = "";
  ngOnInit() {

    this._appService.setPageTitle('Setup Observation Points');
    this._route.params.subscribe(params => {
      this.selectedImplement = +params['implementId'];
      this.attachedImplementSelected = this.selectedImplement;

      this._implementService.GetImplementDetails(this.selectedImplement).subscribe(res => {
        this.isTemplate = res.IsTemplate;
        this.selectedCustomer = res.CustomerId;
        this.loadObservationLists()
      })
    });
    this.loadImplementSchematics();
    this.CheckSelectedImplementCopyFrom();
    this.loadComponentsAndObservationPoints();
    this.loadObservationPointTypes();
    //this.loadOLDObservationPointsForImplement();
    //this.loadOldGETComponents();

    this.unsavedChanges_ComponentSetup = true;
    this.getInspectionTypeList();
    this.getAllComponents();


  }



  //Observation
  onObservationNameFilterChange() {
    if (this.observationListFilter != null && this.observationListFilter.length > 0) {
      this.observationListFiltered = this.observationPoints.filter(item => item.Name != null && item.Name.toLowerCase().includes(this.observationListFilter.toLowerCase()) ? true : false)
    } else {
      this.observationListFiltered = this.observationPoints;
    }
    //this.initialiseSortOrder();
  }

  autoSelectObservationList(OP: any) {
    let list = OP.ObservationPointType == 2 ? this.observationListForCrackObs : this.observationLists;
    if (list?.length === 1) {
      OP.ObservationListId = list[0].Id;
    }
  }

  onObsIsImageChange(id) {
    var ct = this.observationPoints.find(ct => ct.Id == id);
    if (ct != null) {
      ct.IsImage = !ct.IsImage;
    }
  }
  onObsIsAnswerChange(id) {
    var ct = this.observationPoints.find(ct => ct.Id == id);
    if (ct != null) {
      ct.IsAnswer = !ct.IsAnswer;
    }
  }
  onObservationListControlChanged(id, name) {
    var ct = this.observationPoints.find(ct => ct.Id == id && ct.Name == name);
    if (ct != null) {
      ct.Selected = !ct.Selected;
    }

    this.selectedObservationList = this.observationPoints.filter(c => c.Selected).map(item => {
      let op: ObservationPointDetails = {
        Id: item.Id,
        Name: item.Name,
        ObservationPointType: item.ObservationPointType ? item.ObservationPointType : 0,
        ObservationListIds: item.ObservationListIds ? item.ObservationListIds : [],
        ObservationListId: item.ObservationListId,
        Selected: item.Selected,
        NumberOfReadings: item.NumberOfReadings,
        LimitNew: item.LimitNew,
        LimitScrap: item.LimitScrap,
        ComponentName: item.ComponentName,
        ComponentMake: item.ComponentMake,
        ComponentPartNo: item.ComponentPartNo,
        ComponentId: item.ComponentId,
        Active: item.Active,
        QuestionImage: item.QuestionImage,
        QuestionImagePath: item.QuestionImagePath,
        IsNewImage: item.IsNewImage,
        QName: item.QName,
        QDesc: item.QDesc,
        LimitRange: item.LimitRange,
        Measurement: item.Measurement,
        InspectionDate: item.InspectionDate,
        SortOrder: item.SortOrder,
        InspectionTypeID: item.InspectionTypeID,
        IsAnswer: item.IsAnswer,
        IsImage: item.IsImage,
        Xcoord: item.Xcoord,
        Ycoord: item.Ycoord,
        EndXcoord: item.EndXcoord,
        EndYcoord: item.EndYcoord,
        ComponentType: item.ComponentType,
        ComponentTypeId: item.ComponentTypeId,
        ComponentTypeSortOrder: item.ComponentTypeSortOrder,
        CrackSeverityListId: item.CrackSeverityListId
      }
      return op;
    });
  }











  getMakeById(id) {
    if (this.makeList != null && this.makeList.length > 0) {
      var makeDesc = this.makeList.find(w => w.Id == id);
      if (makeDesc != null) {
        return makeDesc.Name;
      }
      return "";
    }
    return "";
  }

  // Toggle filters
  toggleSelectedModels() {
    this.hideSelectedModels = !this.hideSelectedModels;
  }

  toggleUnselectedModels() {
    this.hideUnselectedModels = !this.hideUnselectedModels;
  }

  toggleAllComponents(v) {
    this.componentList.forEach(c => c.Selected = v);
    this.componentListFiltered.forEach(c2 => c2.Selected = v);
  }

  toggleSelectedMPs() {
    this.hideSelectedMPs = !this.hideSelectedMPs;
  }

  toggleUnselectedMPs() {
    this.hideUnselectedMPs = !this.hideUnselectedMPs;
  }

  toggleSelectedOPs() {
    this.hideSelectedOPs = !this.hideSelectedOPs;
  }

  toggleUnselectedOPs() {
    this.hideUnselectedOPs = !this.hideUnselectedOPs;
  }

  toggleAllObsevations(v) {
    this.observationPoints.forEach(c => c.Selected = v);
    this.observationListFiltered.forEach(c2 => c2.Selected = v);
  }

  selectionLogicForModels(isSelected: boolean): boolean {
    if ((!this.hideSelectedModels && !this.hideUnselectedModels)
      || (!this.hideSelectedModels && isSelected && this.hideUnselectedModels)
      || (!this.hideUnselectedModels && !isSelected && this.hideSelectedModels)) {
      return true;
    } else {
      return false;
    }
  }

  selectionLogicForMPs(isSelected: boolean): boolean {
    if ((!this.hideSelectedMPs && !this.hideUnselectedMPs)
      || (!this.hideSelectedMPs && isSelected && this.hideUnselectedMPs)
      || (!this.hideUnselectedMPs && !isSelected && this.hideSelectedMPs)) {
      return true;
    } else {
      return false;
    }
  }

  selectionLogicForOPs(isSelected: boolean): boolean {
    if ((!this.hideSelectedOPs && !this.hideUnselectedOPs)
      || (!this.hideSelectedOPs && isSelected && this.hideUnselectedOPs)
      || (!this.hideUnselectedOPs && !isSelected && this.hideSelectedOPs)) {
      return true;
    } else {
      return false;
    }
  }


  OldObservationPoints: ObservationPointDetails[];
  loadOLDObservationPointsForImplement() {
    this._subscriptions.push(this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe(r => {
      this.OldObservationPoints = r;
    }));
  }
  //OldComponentList: ComponentVM[];
  //loadOldGETComponents() {
  //  this._implementService.ReturnGETComponents(this.selectedImplement).subscribe(result => {
  //    this.OldComponentList = result;
  //  });
  //}










  getImage(image: string) {
    // return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);

  }

  getPosition(posX: string, posY: string) {
    var iPX = (parseFloat(posX));// / 640.0) * this.pageConstants.THUMBNAIL_WIDTH;
    var iPY = (parseFloat(posY)); // 520.0) * this.pageConstants.THUMBNAIL_HEIGHT;
    return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
  }

  getEval(wornPct: number, inspectDate: string) {
    if ((wornPct == 0) && (inspectDate == "Never")) {
      return 'gray';
    } else if (wornPct <= 30) {
      return 'green';
    } else if ((wornPct > 30) && (wornPct <= 60)) {
      return 'yellow';
    } else if ((wornPct > 60) && (wornPct <= 80)) {
      return 'orange';
    } else if (wornPct > 80) {
      return 'red';
    }
  }




  //Schematic photo upload
  onSelectSchematicPhoto(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.selectedSechamnticImage = event.target.files[0]
      reader.onload = (event: any) => { // called once readAsDataURL is completed


        var imageUrl = (event.target.result);

        //resize photo
        this.compressImage(imageUrl).then((res: string) => {
          // console.log("imageUrl", res)
          if (res) {
            //console.log('res', res)

            //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
            // this.uploadPhoto(res.split(',')[1]);
            this.saveSchematicImage(res, this.selectedSechamnticImage);
          }
        })
        //this.saveSchematicImage(imageUrl, this.selectedSechamnticImage);

        this.SchematicImageUpload.nativeElement.value = '';
      }
    }
  }



  compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();




      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        console.log('width', width)
        console.log('height', height)

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }




  //remove implement image
  deleteImplementImage() {
    var saveParams: SaveImplementImageParams = new SaveImplementImageParams();
    saveParams.GETAuto = this.selectedImplement;
    this._subscriptions.push(this._implementService.DeleteImplementImage(saveParams).subscribe(r => {
      if (r) {
        this.toastr.success("Deleted successfully");
        this.implementImage = null;
        this.NewImplementImage = null;
      }
    }));

  }
  // Save the schematic image temporarily.
  saveSchematicImage(imageUrl: string, imageName: File) {
    var sImageUrl = imageUrl.replace(/^data:image\/[a-z]+;base64,/, "");
    sImageUrl = sImageUrl.replace(/^data:image\/\w+;base64,/, "");
    this.schematicList.push({
      Id: this.NewSchematicId,
      Data: sImageUrl,
      ImageName: imageName.name,
      ObservationPoints: [],
      IsNewImage: true,
      SortOrder: this.schematicList.length,
      OBSCount: 0,
      InactiveOBSCount: 0,
      ComponentTypeIds: '',
      IsHidden: false
    });
    this.NewSchematicId++;
  }


  // Load the schematics, components (aka measurement points) and
  // observation points on Tab 3.
  loadComponentsAndObservationPoints() {
    //this.loadComponentsForImplement();
    this.loadObservationPointsForImplement();

  }

  // Load the observation lists for the selected customer.
  loadObservationLists() {
    this._subscriptions.push(this._implementService.GetObservationLists(this.selectedCustomer, this.selectedImplement).subscribe(r => {
      if (r) {
        console.log("Observation Lists:", r);
        this.observationLists = r.filter(f => !f.CrackSeverityList && !f.CrackObsList);
        this.observationListsForCrack = r.filter(f => f.CrackSeverityList);
        // this.observationListFiltered
        // .filter(x => x.ObservationPointType === 2)
        // .forEach(x => x.ObservationListId = this.observationListsForCrack[0].Id);
        this.observationListForCrackObs = r.filter(f => f.CrackObsList);
        // this.observationPoints.forEach(OP => {
        //   this.autoSelectObservationList(OP);
        // });
      }
      console.log("this.observationLists:", this.observationLists, this.observationListsForCrack, this.observationListForCrackObs);
    }));
  }

  // Load the Observation Point types.
  loadObservationPointTypes() {
    this._subscriptions.push(this._implementService.GetObservationPointTypes().subscribe(r => {
      this.observationPointTypes = r;

      //this.observationPointTypes =  r.filter(x=>x.Id != 3)
    }));
  }

  // Load the Observation Points for the selected GET and implement type.
  loadObservationPointsForImplement() {
    this._subscriptions.push(this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe(r => {
      //console.log("r")
      this.observationPoints = r;
      this.observationListFiltered = r;
      console.log(" this.observationListFiltered", this.observationListFiltered)
      this.observationListAfterChanages = r;
      this.OldObservationPoints = r;

      //if (this.observationListsForCrack.length > 0) {
      //  console.log(" this.observationListsForCrack.length", this.observationListsForCrack);
      //  console.log(" this.observationListsForCrack[0].Id", this.observationListsForCrack[0].Id);
      //  console.log(" this.observationListFiltered", this.observationListFiltered);
      //  // this.observationListFiltered
      //  //   .filter(x => x.ObservationPointType === 2 && x.CrackSeverityListId != null)
      //  //   .forEach(x => x.ObservationListId = this.observationListsForCrack[0].Id);
      //}
      //console.log(" after filter observationListFiltered", this.observationListFiltered);
    }));
  }

  // Load the Implement Schematics.
  loadImplementSchematics() {
    this.loading = true;
    // Fix issue where selectedImplement resets to 0 on navigating away.
    var implementId = this.selectedImplement;
    if ((implementId == 0) && (!isNaN(this.attachedImplementSelected))) {
      implementId = this.attachedImplementSelected;
    }
    console.log("implementId", implementId)
    this._subscriptions.push(this._implementService.GetSchematicData(implementId).subscribe(r => {
      this.schematicList = r;
      this.loading = false;
    }));
  }








  resetSelectType(e) {
    this.selectedImplementType = 0
  }



  onNumReadingsEntered(OP, e) {

    if (e.target.value < 0) {
      OP.NumReadings = 0;
      this.toastr.error("Please enter a value between 0 - 5 for the readings");
      // this.isvalidStep3 = false
    } else if (e.target.value > 5) {
      OP.NumReadings = 5;
      this.toastr.error("Please enter a value between 0 - 5 for the readings")
      //this.isvalidStep3 = false

    } else {
      OP.NumReadings = parseInt(e.target.value.toString().replace('+', '').replace('-', ''))

    }

    //OP.NumReadings = parseInt(e.target.value.toString().replace('+', '').replace('-', ''))
  }

  onLimitsEntered(OP, e) {
    if (e.target.value > 0) {
      if (OP.NumReadings == 0) {
        this.toastr.error("Can not enter Limits, unless you have specified No of reading");
        e.target.value = 0;
      }
    }

  }
  onNewOPLimitNewEntered(e) {
    this.newOPLimitNew = e.target.value;
  }

  onNewOPLimitScrapEntered(e) {
    this.newOPLimitScrap = e.target.value;
  }

  onPartNumberChanged(MP, e) {
    MP.PartNo = e.target.value;
  }

  // Handle the right-click 'select and copy' context menu.
  // e: the right-click context menu event.
  // isMP: if true then it is for measurement point, otherwise an observation point.
  // id: the Id of the measurement point or observation point in the row selected.
  // category: whether this is the make, observation list, initial length or worn length.
  // val: the value to be copied across.
  displayContextMenu(e, isMP, id, category) {
    this.showContextMenu = true;
    this.contextMenuY = e.pageY + 'px';
    this.contextMenuX = e.pageX + 'px';


    this.selectionData.Id = id;
    this.selectionData.Category = category;
    if (category == "ObservationList") {
      this.selectionData.Val = isMP
      this.selectionData.IsMP = false;
    }
    else {
      this.selectionData.Val = e.target.value;
      this.selectionData.IsMP = isMP;
    }

    this.clearHighlights();
  }

  // Hide the context menu.
  hideContextMenu(e) {
    this.showContextMenu = false;
  }

  // Clear the highlight for previously updated cells.
  clearHighlights() {
    this.showAllCells = false;
    this.showVacantCells = false;
  }

  // Copy the selection data to all cells for the category. (canOverwrite=true)
  copySelectionToAll(e) {
    this.copySelection(e, true);
  }

  // Copy the selection data only to the vacant cells for the category. (canOverwrite=false)
  copySelectionToVacant(e) {
    this.copySelection(e, false);
  }

  // Handles the main logic for copying selected data to all cells for the category.
  copySelection(e, canOverwrite) {
    if (this.selectionData != null) {
      // Handle Measurement Points
      if (this.selectionData.IsMP) {

        for (var i = 0; i < this.componentList.length; i++) {
          this.updateDataBasedOnCategory(this.componentList, i, canOverwrite);
        }
      }

      // Handle Observation Points
      else {
        for (var i = 0; i < this.observationPoints.length; i++) {
          this.updateDataBasedOnCategory(this.observationPoints, i, canOverwrite);
        }
      }
    }
  }

  // Handles the assignment logic for each category.
  updateDataBasedOnCategory(src, index, canOverwrite) {

    if (this.selectionIsMake()) {
      if ((src[index].Make == 0) || (canOverwrite)) {
        src[index].Make = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationList()) {
      if ((src[index].ObservationListIds == 0) || (canOverwrite)) {
        src[index].ObservationListIds = this.selectionData.Val;
      }
      if ((src[index].ObservationListId == 0) || (canOverwrite)) {
        src[index].ObservationListId = this.selectionData.Val;
      }
    } else if (this.selectionIsLimitNew()) {
      if (this.checkIfVacant(this.pageConstants.COL_INITIAL_LENGTH, src[index].LimitNew, src[index].LimitScrap) || (canOverwrite)) {
        src[index].LimitNew = this.selectionData.Val;
      }
    } else if (this.selectionIsLimitScrap()) {
      if (this.checkIfVacant(this.pageConstants.COL_WORN_LENGTH, src[index].LimitNew, src[index].LimitScrap) || (canOverwrite)) {
        src[index].LimitScrap = this.selectionData.Val;
      }
    } else if (this.selectionIsPartNo()) {
      if (this.checkIfVacant(this.pageConstants.COL_PART_NO, src[index].PartNo, null) || (canOverwrite)) {
        src[index].PartNo = this.selectionData.Val;
      }
    } else if (this.selectionIsNumberOfReadings()) {
      if (this.checkIfVacant(this.pageConstants.COL_NUM_READINGS, src[index].NumberOfReadings, null) || (canOverwrite)) {
        src[index].NumberOfReadings = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationPointType()) {
      if ((src[index].ObservationPointType == 0) || (canOverwrite)) {
        src[index].ObservationPointType = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationPointName()) {
      if (this.checkIfVacant(this.pageConstants.COL_OP_NAME, src[index].Name, null) || (canOverwrite)) {
        src[index].Name = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationPointQName()) {
      if (this.checkIfVacant(this.pageConstants.COL_OP_Q_NAME, src[index].QName, null) || (canOverwrite)) {
        src[index].QName = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationPointQDesc()) {
      if (this.checkIfVacant(this.pageConstants.COL_OP_Q_DESC, src[index].QDesc, null) || (canOverwrite)) {
        src[index].QDesc = this.selectionData.Val;
      }
    }
  }

  // Returns true if the selected cell is for 'Make'.
  selectionIsMake() {
    if (this.selectionData.Category == this.pageConstants.COL_MAKE) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation List'.
  selectionIsObservationList() {
    if (this.selectionData.Category == this.pageConstants.COL_OBSERVATION_LIST) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Initial Length'.
  selectionIsLimitNew() {
    if (this.selectionData.Category == this.pageConstants.COL_INITIAL_LENGTH) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Worn Length'.
  selectionIsLimitScrap() {
    if (this.selectionData.Category == this.pageConstants.COL_WORN_LENGTH) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Part No'.
  selectionIsPartNo() {
    if (this.selectionData.Category == this.pageConstants.COL_PART_NO) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Number Of Readings'.
  selectionIsNumberOfReadings() {
    if (this.selectionData.Category == this.pageConstants.COL_NUM_READINGS) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation Point Type'.
  selectionIsObservationPointType() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_TYPE) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation Point Name'.
  selectionIsObservationPointName() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_NAME) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation Point Name'.
  selectionIsObservationPointQName() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_Q_NAME) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation Point Name'.
  selectionIsObservationPointQDesc() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_Q_DESC) {
      return true;
    }
    return false;
  }

  selectionIsObservationPointLimitRange() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_LIMITRANGE) {
      return true;
    }
    return false;
  }

  selectionIsObservationPointMeasurement() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_MEASUREMENT) {
      return true;
    }
    return false;
  }
  // Check if the cell is vacant.
  // The Make and Observation List cells are vacant if the first entry is selected.
  // Initial and Worn lengths are considered blank if both those cells are 0,
  // or if one of those cells is empty.
  // Part number and Number of Readings are vacant if the cell contains no valid characters or is null.
  checkIfVacant(cat, val1, val2) {
    if (cat == this.pageConstants.COL_MAKE || cat == this.pageConstants.COL_OBSERVATION_LIST || cat == this.pageConstants.COL_OP_TYPE) {
      if (val1 == 0) {
        return true;
      }
    }

    else if (cat == this.pageConstants.COL_INITIAL_LENGTH || cat == this.pageConstants.COL_WORN_LENGTH) {
      if (cat == this.pageConstants.COL_INITIAL_LENGTH && (val1 == "" || val1 == null)) {
        return true;
      }
      else if (cat == this.pageConstants.COL_WORN_LENGTH && (val2 == "" || val2 == null)) {
        return true;
      }
      else if (val1 == 0 && val2 == 0) {
        return true;
      }
    }

    else if ((cat == this.pageConstants.COL_PART_NO) || (cat == this.pageConstants.COL_NUM_READINGS) || (cat == this.pageConstants.COL_OP_NAME) || (cat == this.pageConstants.COL_OP_Q_NAME) || (cat == this.pageConstants.COL_OP_Q_DESC)) {
      if (val1 == "" || val1 == null) {
        return true;
      }
    }

    return false;
  }

  // Enable or Disable highlighting for selected vacant cells.
  toggleVacantCells(status) {
    this.showVacantCells = status;
  }

  // Enable or Disable highlighting for all selected cells.
  toggleAllCells(status) {
    this.showAllCells = status;
  }

  //////////////////////////////////////////////
  // Helper functions for CSS Highlight logic //
  //////////////////////////////////////////////

  highlightCopyImplementIcon() {
    this.mouseoverITReplicate = !this.mouseoverITReplicate;
  }

  highlightMake(val) {
    if ((this.showAllCells) || (this.showVacantCells && val == 0)) {
      if (this.selectionIsMake() && this.selectionData.IsMP) {
        return true;
      }
    }
    return false;
  }

  highlightObservationList(val) {
    if ((this.showAllCells) || (this.showVacantCells && val == 0)) {
      if (this.selectionIsObservationList()) {
        return 2;
      }
    }
    return 0;
  }

  highlightLimitNew(il, wl) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_INITIAL_LENGTH, il, wl))) {
      if (this.selectionIsLimitNew()) {
        if (this.selectionData.IsMP) {
          return 1;
        } else {
          return 2;
        }
      }
    }
    return 0;
  }

  highlightLimitScrap(il, wl) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_WORN_LENGTH, il, wl))) {
      if (this.selectionIsLimitScrap()) {
        if (this.selectionData.IsMP) {
          return 1;
        } else {
          return 2;
        }
      }
    }
    return 0;
  }

  highlightPartNo(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_PART_NO, val, null))) {
      if (this.selectionIsPartNo() && this.selectionData.IsMP) {
        return true;
      }
    }
    return false;
  }

  highlightNumberOfReadings(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_NUM_READINGS, val, null))) {
      if (this.selectionIsNumberOfReadings()) {
        return true;
      }
    }
    return false;
  }

  highlightName(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_NAME, val, null))) {
      if (this.selectionIsObservationPointName()) {
        return true;
      }
    }
    return false;
  }

  highlightQName(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_Q_NAME, val, null))) {
      if (this.selectionIsObservationPointQName()) {
        return true;
      }
    }
    return false;
  }
  highlightQDesc(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_Q_DESC, val, null))) {
      if (this.selectionIsObservationPointQDesc()) {
        return true;
      }
    }
    return false;
  }

  highlightLimitRange(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_LIMITRANGE, val, null))) {
      if (this.selectionIsObservationPointLimitRange()) {
        return true;
      }
    }
    return false;
  }

  highlightMeasurement(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_MEASUREMENT, val, null))) {
      if (this.selectionIsObservationPointMeasurement()) {
        return true;
      }
    }
    return false;
  }

  highlightType(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_TYPE, val, null))) {
      if (this.selectionIsObservationPointType()) {
        return true;
      }
    }
    return false;
  }

  /////////////////////////////
  // Handle Schematic Window //
  /////////////////////////////

  openEnlargedImage(iImage, imgOrSchematic) {
    var img1: SchematicDataVM = new SchematicDataVM();
    img1.Id = 0;
    img1.ObservationPoints = null;
    img1.Data = iImage;

    this.openSchematicWindow(img1, imgOrSchematic);
  }
  isTemplate: boolean = false;
  openSchematicWindow(schematic, imgOrSchematic) {


    this.schematicPositionX = 250;
    this.schematicPositionY = 250;

    this.prevMouseX = 0;
    this.prevMouseY = 0;
    this.selectedSchematic = schematic;
    this.showSchematic = true;
    if (imgOrSchematic == 1) {
      this.draggableSchematicTitle = "Implement Image";
    } else if (imgOrSchematic == 2) {
      this.draggableSchematicTitle = "Schematic";
    }
  }

  //edit observation point dialog
  openSchematicWindowforEdit(obserationID, imgOrSchematic) {

    if (imgOrSchematic == 1) {
      this.draggableSchematicTitle = "Implement Image";
    } else if (imgOrSchematic == 2) {
      this.draggableSchematicTitle = "Schematic";
    }
    this._implementService.GetSchematicDataForEditObsevationPoint(obserationID).subscribe(r => {
      console.log('r', r)


      if (r.length > 0) {
        this.selectedSchematicEdit = r[0]
        const addSectionDialog = this.dialog.open(SchemanticOpPopupEditComponent, {

          data: {
            schematic: this.selectedSchematicEdit,
            currentStep: this.currentStep,
            mouseoverOPId: this.mouseoverOPId,
            title: this.draggableSchematicTitle

          }
        });
        addSectionDialog.afterClosed().subscribe(details => {

        });

      }

    });


  }





  //GET-424
  //delete observation point
  deleteOP(op) {
    console.log("op_", op)
    if (op.NumberOfReadings >= 1) {
      //check any readings exists
      this.check_op_has_any_readings(op.Id)
      //if not delete op

      //if exists disable button and alert
    } else {

    }


  }

  check_op_has_any_readings(op_id) {

    this._implementService.DeleteObservationPoint(op_id).subscribe((r: any) => {
      console.log('r', r)
      let json_ = JSON.parse(r)
      if (json_['status'] == true) {
        this.toastr.success(json_['message']);
        this.loadObservationPointsForImplement();
        //window.location.reload(false); 
      } else {

        console.log('r___', json_['message'], json_['status'])
        this.toastr.error(json_['message']);
      }
    })


  }

  onCloseSchematicWindow(e) {
    this.showSchematic = false;
    this.loadObservationPointsForImplement();
    this.loadObservationLists();
  }

  onSaveObservation(e) {
    this.loadObservationPointsForImplement();
    this.loadObservationLists();
  }


  onMouseButton_Schematic(e) {
    this.isMouseDown = e.buttons === 1;
    e.preventDefault();

    this.prevMouseX = e.pageX;
    this.prevMouseY = e.pageY;
  }

  onMouseMove_Schematic(e) {
    if (this.isMouseDown) {

      if ((this.prevMouseX > 0) && (this.prevMouseY > 0)) {
        this.schematicPositionX += (e.pageX - this.prevMouseX);
        this.schematicPositionY += (e.pageY - this.prevMouseY);

        this.prevMouseX = e.pageX;
        this.prevMouseY = e.pageY;
      }

      else {
        this.prevMouseX = e.pageX;
        this.prevMouseY = e.pageY;
      }
    }
    e.preventDefault();
  }


  //////////////////////////////////////
  // Mouse hover logic for table rows //
  //////////////////////////////////////

  onMouseOverMP(id) {
    this.mouseoverMPId = id;
  }

  onMouseOutMP() {
    this.mouseoverMPId = 0;
  }

  onMouseOverOP(id) {
    this.mouseoverOPId = id;
  }

  onMouseOutOP() {
    this.mouseoverOPId = 0;
  }




  indexarr = []

  goToStep(step: number) {
    //this.CheckChanges();  //deleted  
    this.observationPoints.map((item, index) => {
      this.indexarr.push(index);
    });

    switch (step) {
      case 3:
        if ((this.cbApplyToOne == true) && (this.cbApplyToAll == true)) {

          this.toastr.error('Please select only one checkbox to apply these changes');
        }

        else {
          for (var i = 0; i < this.observationPoints.length; i++) {
            this.observationPoints[i].SortOrder = this.indexarr[i]
          }
          // this.CheckChanges();
          this._implementService.SaveObservationPointSortDetailsAll(this.observationPoints, this.selectedImplement, this.cbApplyToAll).subscribe(res => {
            console.log(res)
            if (res >= 0) {
              console.log("works")
              this.submitChanges();
              //this._router.navigate(['/implementdetails', this.selectedImplement]);
            }
            //this.CheckChanges();    //Added new comment
          })
        }
        break;
    }
  }

  validateAndProcessTab2() {
    this.loadComponentsAndObservationPoints();
    this.currentStep = 2;
  }

  // Submit changes made to measurement points and observation points.
  submitChanges() {
    console.log("before validation", 1)
    var valiadateResult = this.validationForComponentsandOPTab3();
    console.log("after validation", 2)
    //this.currentStep = 3;
    this.ismodified = true;
    if (valiadateResult.Status) {
      if (this.ismodified) {
        //let isChnages = this.checkAnyChnagesHappend();
        //console.log("Chack chnages_________", isChnages)
        this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe(r => {
          this.observationPointsOld = r;

          if (this.OldObservationPoints != null) {
            this.onlyInA = this.observationPoints.filter(this.comparer(this.observationPointsOld));
            console.log("checkAnyChnagesHappend", this.onlyInA.length);
            if (this.onlyInA.length > 0) {
              console.log("his.onlyInA.length", this.onlyInA.length)

              if ((this.cbApplyToOne == true) && (this.cbApplyToAll == true)) {

                this.toastr.error('Please select only one checkbox to apply these changes');
                this.currentStep = 0;
                return
              }
              else if ((this.cbApplyToAll == false) && (this.cbApplyToOne == false)) {

                this.toastr.error('Please select whether you want to apply changes to this implement or all instances of this implement');
                this.currentStep = 0;
                return
              }
              else {
                if (this.cbApplyToAll == true) {
                  var issaved_1 = this.UpdateChangesinTab3ToAll();
                  console.log("saved all__!!", issaved_1);
                  if (issaved_1 == true) {
                    this.currentStep = 3;
                    this.toastr.success('Successfully modified all implements.');
                    this._router.navigate(['/implementdetails', this.selectedImplement]);
                  }
                }
                else {
                  var issaved_2 = this.UpdateChangesinTab3ToThis();
                  console.log("saved to one!!", issaved_2);
                  if (issaved_2) {
                    this.currentStep = 3;
                    this.toastr.success('Successfully modified this implement.');
                    this._router.navigate(['/implementdetails', this.selectedImplement]);
                  }
                }
              }
            }
            else {
              if (!valiadateResult.Status) {
                this.currentStep = 0;
                this.toastr.error(valiadateResult.Message);
              }
              else {
                this._router.navigate(['/implementdetails', this.selectedImplement]);
              }
            }
          }

        });

        //if (isChnages==true) {
        //  console.log("his.onlyInA.length____", this.onlyInA)
        //  if (this.onlyInA.length > 0) {
        //    if (this.onlyInA.length >= 1) {
        //       console.log("his.onlyInA.length", this.onlyInA.length)

        //      if ((this.cbApplyToOne == true) && (this.cbApplyToAll == true)) {

        //        this.toastr.error('Please select only one checkbox to apply these changes');
        //        return
        //      }
        //      else if ((this.cbApplyToAll == false) && (this.cbApplyToOne == false)) {

        //        this.toastr.error('Please select whether you want to apply changes to this implement or all instances of this implement');
        //        return
        //      }
        //      else {
        //        if (this.cbApplyToAll == true) {                 
        //          var issaved_1 = this.UpdateChangesinTab3ToAll();
        //          console.log("saved all__!!", issaved_1);
        //          if (issaved_1==true) {
        //            this.currentStep = 3;
        //            this.toastr.success('Successfully modified all implements.');

        //          }
        //        }
        //        else {
        //          var issaved_2 = this.UpdateChangesinTab3ToThis();
        //          console.log("saved to one!!", issaved_2);
        //          if (issaved_2) {
        //            this.currentStep = 3;
        //            this.toastr.success('Successfully modified this implement.');

        //          }
        //        }
        //      }
        //    }
        //  }
        //  else if (this.onlyInA.length == 0) {

        //    // this.toastr.warning('Did not identify any changes');
        //    this.currentStep = 3;
        //    this.haschanges = false
        //   // this._router.navigate(['/implementdetails', this.selectedImplement]);
        //  }
        //}
        //else {
        //  if (!valiadateResult.Status) {
        //    this.toastr.error(valiadateResult.Message);
        //  }
        //}
      }
      else {
        if (!valiadateResult.Status) {
          this.currentStep = 0;
          this.toastr.error(valiadateResult.Message);
        } else {
          this.currentStep = 3;
          this._router.navigate(['/implementdetails', this.selectedImplement]);
          // this._router.navigate(['/implementdetails', this.selectedImplement]);
        }

      }
    }
    else {
      this.currentStep = 0;
      this.toastr.error(valiadateResult.Message);
    }
    console.log("after if__")
    console.log("this.currentStep", this.currentStep)

    if (this.currentStep == 3) {
      this._router.navigate(['/implementdetails', this.selectedImplement]);
    }

  }




  HasChildImplements: boolean
  //check implement is copyfrom
  CheckSelectedImplementCopyFrom() {
    //this._implementService.CheckhasCopyFrom(this.selectedImplement).subscribe(res => {
    //  console.log("resulttt", res)
    //  if (res) {
    //    this.cbApplyToOne = false;
    //    this.cbApplyToAll = false;
    //    this.HasChildImplements = true;
    //  } else {
    //    this.cbApplyToOne = true;
    //    this.cbApplyToAll = false;
    //    this.HasChildImplements = false;
    //  }
    //})
  }


  // Saves any changes made to observation points.
  saveObservationPoints() {
    var params: SaveObservationPointParams = new SaveObservationPointParams();
    params.GetAuto = this.attachedImplementSelected;
    params.ObservationPoints = this.observationPoints;

    this._implementService.SaveObservationPoints(params).subscribe(r => {
      if (r < 0) {
        this.toastr.error(this.pageErrors.ERROR_SAVING_OP);
      } else {
        // Now mark setup as complete.
        this.setupComplete = true;
      }
    })
  }


  // For 'Setup on equipment' ensure that customer, jobsite and equipment selections have been made.
  // For 'Setup in inventory' ensure that customer and jobsite are selected.
  // Otherwise validation fails.
  stepTwoIsValid(): boolean {
    return true;
  }

  stepThreeIsValid(): boolean {
    return true;
  }





  /////////////////////
  //Validate Tab3 ////
  ////////////////////

  validationForComponentsandOPTab3(): ValidationErrorStatus {
    var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
    validationResult.Status = true;
    validationResult.Message = "";
    //console.log("this.observationPoints:", this.observationPoints);
    if (this.observationPoints.length > 0) {
      this.isvalidStep3 = true
      this.observationPoints.forEach(element => {
        if ((element.Name == "") || (element.Name.trim().length < 1)) {
          validationResult.Status = false;
          validationResult.Message = "Observation Name cannot be empty";
        }
        if (element.ObservationPointType == 0) {
          validationResult.Status = false;
          validationResult.Message = "Observation Type cannot be empty";
        }
        //console.log("element.ObservationPointType :", element.ObservationPointType );
        if ((element.NumberOfReadings != 0) && (element.ObservationPointType > 0)) {
          //if ((element.LimitNew == 0 || element.LimitScrap == 0) && (element.ObservationPointType != 3) && (element.ObservationPointType != 4) && (element.ObservationPointType != 5)  && (element.ObservationPointType != 6)) {
          //  validationResult.Status = false;
          //  validationResult.Message = "Limits cannot be empty";
          //}

          if (element.ObservationPointType == 1) {
            //console.log("element.ObservationPointType :", element);
            if (element.NumberOfReadings == 0 || element.NumberOfReadings == null) {
              if (element.LimitNew != 0 || element.LimitScrap != 0) {
                validationResult.Status = false;
                validationResult.Message = "No of Readings can not be empty";
              }
            }
            //https://infotrak.atlassian.net/browse/TT-10219
            //else {
            //  if (element.LimitScrap > element.LimitNew) {
            //    //console.log("element.ObservationPointType :", element.LimitScrap, element.LimitNew);
            //    validationResult.Status = false;
            //    validationResult.Message = "New Limit cannot be lower than Used Limit";
            //  }
            //  //if (element.LimitScrap == 0 && element.LimitNew > 0) {             
            //  //  validationResult.Status = true;
            //  //  //console.log("element.LimitScrap == 0 && element.LimitNew > 0:", element.LimitScrap, element.LimitNew);
            //  //}                   
            //}
          }
          else if (element.ObservationPointType == 2) {
            if (element.NumberOfReadings == 0 || element.NumberOfReadings == null) {
              if (element.LimitNew != 0 || element.LimitScrap != 0) {
                validationResult.Status = false;
                validationResult.Message = "No of Readings can not be empty";
              }
            }
            else {
              if (element.LimitNew > element.LimitScrap) {
                validationResult.Status = false;
                validationResult.Message = "Crack Length(New Limit) must not exceed the Maximum Crack Length(Used Limit)";
              }
              //if (element.LimitNew == 0 && element.LimitScrap > 0) {
              //  validationResult.Status = true;
              //  //console.log("element.LimitNew == 0 && element.LimitScrap > 0:", element.LimitScrap, element.LimitNew);
              //}
            }
          }
          else if (element.ObservationPointType == 3) {
            // if (element.NumberOfReadings == 0 || element.NumberOfReadings == null) {
            //     validationResult.Status = false;
            //     validationResult.Message = "No of Readings can not be empty.";
            // }
            if (element.NumberOfReadings > 1) {
              console.log("Eval", element.LimitNew, element.LimitScrap, element.NumberOfReadings)
              validationResult.Status = false;
              validationResult.Message = "Observation Points of type Eval may have 1 reading."
            }
            else if (element.LimitNew > 0 || element.LimitScrap > 0) {
              console.log("Eval", element.LimitNew, element.LimitScrap, element.NumberOfReadings)
              validationResult.Status = false;
              validationResult.Message = "Observation Points of type Eval may not have limits.";
            }
          }
        }
        else if ((element.NumberOfReadings == 0 || element.NumberOfReadings == null) && element.ObservationPointType != 3 && element.ObservationPointType != 4 && element.ObservationPointType != 5 && element.ObservationPointType != 6) {
          validationResult.Status = false;
          validationResult.Message = "No of Readings can not be empty.";
        }
      });
    }
    console.log("validationResult :", validationResult);
    return validationResult;
  }

  //update observation to the only selected implement
  UpdateChangesinTab3ToThis(): boolean {
    for (var i = 0; i < this.onlyInA.length; i++) {
      var saveParams: UpdateObservationPointModal = new UpdateObservationPointModal();
      saveParams.Name = this.onlyInA[i].Name;
      saveParams.ObservationList = this.onlyInA[i].ObservationListIds;
      saveParams.ObservationListId = this.onlyInA[i].ObservationListId == 0 ? null : this.onlyInA[i].ObservationListId;
      saveParams.OPTypeId = this.onlyInA[i].ObservationPointType;
      saveParams.NoOfReadings = this.onlyInA[i].NumberOfReadings;
      saveParams.LimitsNew = this.onlyInA[i].LimitNew;
      saveParams.LimitsScrap = this.onlyInA[i].LimitScrap;
      saveParams.ID = this.onlyInA[i].Id;
      saveParams.ComponentID = this.onlyInA[i].ComponentId;
      saveParams.isApplytoAll = this.cbApplyToAll;
      saveParams.IsActive = this.onlyInA[i].Active;
      saveParams.ImplementId = this.selectedImplement;
      saveParams.QName = this.onlyInA[i].QName;
      saveParams.QDesc = this.onlyInA[i].QDesc;
      saveParams.LimitRange = this.onlyInA[i].LimitRange;
      saveParams.Measurement = this.onlyInA[i].Measurement;
      saveParams.InspectionTypeID = this.onlyInA[i].InspectionTypeID;
      saveParams.IsAnswer = this.onlyInA[i].IsAnswer;
      saveParams.IsImage = this.onlyInA[i].IsImage;
      saveParams.Xcoord = this.onlyInA[i].Xcoord;
      saveParams.Ycoord = this.onlyInA[i].Ycoord;
      saveParams.EndXcoord = this.onlyInA[i].EndXcoord;
      saveParams.EndYcoord = this.onlyInA[i].EndYcoord;



      this._implementService.UpdateObservationPointForThisImpl(saveParams).subscribe((result: any) => {
        if (result > 0) {
          let savedtothisSucess = true
          return savedtothisSucess;
        }

      });
    }
    this.currentStep = 3;
    // this._router.navigate(['/implementdetails', this.selectedImplement]);
    return true;
  }
  //update the observation to all the implements
  savedallSucess: boolean = false

  UpdateChangesinTab3ToAll(): boolean {
    console.log("this.onlyInA________", this.onlyInA)
    if (this.onlyInA.length > 0) {
      for (var i = 0; i < this.onlyInA.length; i++) {
        var saveParams: UpdateObservationPointModal = new UpdateObservationPointModal();
        saveParams.Name = this.onlyInA[i].Name;
        saveParams.ObservationList = this.onlyInA[i].ObservationListIds;
        saveParams.ObservationListId = this.onlyInA[i].ObservationListId == 0 ? null : this.onlyInA[i].ObservationListId;
        saveParams.OPTypeId = this.onlyInA[i].ObservationPointType;
        saveParams.NoOfReadings = this.onlyInA[i].NumberOfReadings;
        saveParams.LimitsNew = this.onlyInA[i].LimitNew;
        saveParams.LimitsScrap = this.onlyInA[i].LimitScrap;
        saveParams.ID = this.onlyInA[i].Id;
        saveParams.ComponentID = this.onlyInA[i].ComponentId;
        saveParams.isApplytoAll = this.cbApplyToAll;
        saveParams.IsActive = this.onlyInA[i].Active;
        saveParams.ImplementId = this.selectedImplement;
        saveParams.QName = this.onlyInA[i].QName;
        saveParams.QDesc = this.onlyInA[i].QDesc;
        saveParams.InspectionTypeID = this.onlyInA[i].InspectionTypeID;
        saveParams.IsAnswer = this.onlyInA[i].IsAnswer
        saveParams.IsImage = this.onlyInA[i].IsImage
        saveParams.Xcoord = this.onlyInA[i].Xcoord;
        saveParams.Ycoord = this.onlyInA[i].Ycoord;
        saveParams.EndXcoord = this.onlyInA[i].EndXcoord;
        saveParams.EndYcoord = this.onlyInA[i].EndYcoord;


        console.log("saveParams11111", saveParams)
        this._implementService.UpdateObservationPointForAll(saveParams).subscribe((result: any) => {
          let savedsucess = result;
          if (result > 0) {
            //this._router.navigate(['/implementdetails', this.selectedImplement]);

            return this.savedallSucess = true
          }
          else {
            return this.savedallSucess = false
          }
        });
      }

    } else {
      console.log("saveParams22222", saveParams)
      var saveParams: UpdateObservationPointModal = new UpdateObservationPointModal();
      saveParams.isApplytoAll = this.cbApplyToAll;
      saveParams.ImplementId = this.selectedImplement;
      this._implementService.UpdateObservationPointForAll(saveParams).subscribe((result: any) => {
        let savedsucess = result;
        if (result > 0) {
          // this._router.navigate(['/implementdetails', this.selectedImplement]);
          return this.savedallSucess = true

        }
        else {
          return this.savedallSucess = false
        }
      });
    }
    return this.savedallSucess;

  }

  checkValueAll(checked) {
    this.AllChecked = checked;
  }
  checkValueOne(checked) {

    this.OneChecked = checked;
  }
  //identify changes to the step three table
  checkAnyChnagesHappend(): boolean {
    var result = false;
    this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe(r => {
      this.observationPointsOld = r;

      if (this.OldObservationPoints != null) {
        this.onlyInA = this.observationPoints.filter(this.comparer(this.observationPointsOld));
        console.log("checkAnyChnagesHappend", this.onlyInA.length);
        if (this.onlyInA.length >= 1) {
          this.haschanges = true
          result = true
        }
        else {
          this.haschanges = false
          result = false
        }
      }
      else result = false;
    });
    return result;
  }
  //check changes in mouseover in submit button
  CheckChanges() {
    this.checkAnyChnagesHappend();
  }

  //get differnce in between two arrays
  comparer(otherArray) {
    return function (current) {
      return otherArray.filter(function (other) {
        return other.Name == current.Name
          && other.NumberOfReadings == current.NumberOfReadings
          && other.ObservationPointType == current.ObservationPointType
          && other.LimitNew == current.LimitNew
          && other.LimitScrap == current.LimitScrap
          && other.LimitRange == current.LimitRange
          && other.Measurement == current.Measurement
          && other.Active == current.Active
          //&& other.ObservationListIds.length == current.ObservationListIds.length
          && other.ObservationListId == current.ObservationListId
          && other.QName == current.QName
          && other.QDesc == current.QDesc
          && other.InspectionTypeID == current.InspectionTypeID
          && other.IsAnswer == current.IsAnswer
          && other.IsImage == current.IsImage
          && other.Xcoord == current.Xcoord
          && other.Ycoord == current.Ycoord
          && other.EndXcoord == current.EndXcoord
          && other.EndYcoord == current.EndYcoord

        //&& (other.ObservationListIds.map((i, index) => {
        //  current.ObservationListIds[index] == other.ObservationListIds[index]
        //}))

      }).length == 0;
    }
  }



  checkExistingOP(val) {
    let count = 0
    if (val.trim().length < 1 || val == "") {
      this.toastr.error('The Observation name cannot be empty');
      //this.isvalidStep3 = false
      // return
    }
    this.observationPoints.map(x => {
      if (x.Name.toLowerCase() == val.toLowerCase()) {
        count = count + 1;
      }

    })
    if (count > 1) {
      this.toastr.error('This Observation name already exists!');
      //this.isvalidStep3 = false
      //return
    }
  }



  returnIndexOfItem(id, isNew) {
    for (var i = 0; i < this.schematicList.length; i++) {
      var x = this.schematicList[i];
      if (x.Id == id && x.IsNewImage == isNew) {
        return i;
      }
    }

    return -1;
  }

  //deleteimage(id, isNew, array) {
  //  if (array.length == 0) {
  //    if (isNew) {
  //      var index = this.returnIndexOfItem(id, isNew);
  //      if (index >= 0) {
  //        this.schematicList.splice(index, 1);
  //      }
  //    } else {
  //      this._implementService.DeleteImplementSchematicImage(id, this.selectedImplement).subscribe(r => {
  //        if (r) {
  //          var index = this.returnIndexOfItem(id, isNew);
  //          if (index >= 0) {
  //            this.schematicList.splice(index, 1);
  //          }
  //        } else {
  //          this.toastr.error("Unable to delete schematic!");
  //        }
  //      });
  //    }

  //  }
  //  if (array.length > 0) {
  //    this.toastr.error('This schematic currently has Observation points allocated!');
  //  }
  //}

  ValidateNumberInputs(e) {
    if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 110 || e.keyCode == 190 || e.keyCode == 46) {
      return true;
    }
    return false;
  }



  //uplaod OPQuestion Image

  selectedFile: File
  ModelImage_fromPC: string
  QuestionImage: string
  onSelectOPQuestionImage(event: any, id: number) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFile = event.target.files[0];
      reader.onloadend = (e) => {
        this.uploadPhoto(reader.result as string, id);

      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  // onSelectModalImage(event: any): void {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e: any) => {
  //       console.log('Image loaded:', e.target.result);
  //       this.selectedQImage = e.target.result;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }


// onSelectModalImage(event: any): void {
//   const file = event.target.files[0];
//   if (file) {
//     const isHeic =
//       file.type === "image/heic" ||
//       file.name.toLowerCase().endsWith(".heic");
//     const processFile = (f: File) => {
//       const reader = new FileReader();
//       reader.onload = (e: any) => {
//         console.log('Image loaded:', e.target.result);
//         this.selectedQImage = e.target.result;
//       };
//       reader.readAsDataURL(f);
//     };
//     if (isHeic) {
//       (heic2any as any).default({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.8
//       })
//       .then((result: any) => {
//         const convertedBlob = Array.isArray(result) ? result[0] : result;
//         const convertedFile = new File([convertedBlob], "converted.jpg", {
//           type: "image/jpeg"
//         });
//         processFile(convertedFile);
//       })
//       .catch((err: any) => {
//         console.error("HEIC conversion failed", err);
//         this.toastr.error("Failed to convert HEIC image. Please try a different image.");
//       });
//     } else {
//       processFile(file);
//     }
//     event.target.value = null;
//   }
// }

async onSelectModalImage(event: any): Promise<void> {

  const file = event.target.files[0];

  if (!file) {
    return;
  }

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      console.log('Image loaded:', e.target.result);

      this.selectedQImage = e.target.result;

    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg",   // Use "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this.toastr.error(
      "Failed to convert HEIC image. Please try a different image."
    );

  }

  event.target.value = null;

}
  uploadPhoto(newPhoto: string, ID: number) {
    this.ModelImage_fromPC = newPhoto.split(",")[1];

    var saveParams: SaveQuestionImageParams = new SaveQuestionImageParams();
    saveParams.ObservationPointId = ID;
    saveParams.ImageData = this.ModelImage_fromPC;

    this._subscriptions.push(this._implementService.SaveQuestionImage(saveParams).subscribe(r => {
      if (r) {
        this.observationPoints.filter(x => {
          if (x.Id == ID) {
            x.QuestionImage = this.ModelImage_fromPC;
            this.selectedQImage = x.QuestionImage;
            x.IsNewImage = true;
            this.isNewSelectedQImage = x.IsNewImage;
            this.toastr.success("Uploaded successfully")
          }
        })
      }
    }));


  }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }

  //end upload
  deleteQuestionimage(OP_ID: number, IsNew: boolean) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        message: 'Are you sure you want to delete this observation point image?',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        const saveParams: SaveQuestionImageParams = new SaveQuestionImageParams();
        saveParams.ObservationPointId = OP_ID;

        this._subscriptions.push(
          this._implementService.DeleteQuestionImage(saveParams).subscribe(r => {
            if (r) {
              this.observationPoints.forEach(x => {
                if (x.Id === OP_ID) {
                  x.QuestionImage = "";
                  x.QuestionImagePath = "";
                  this.selectedQImage = "";
                }
              });
              this.toastr.success("Deleted successfully");
            } else {
              this.toastr.error("Delete Unsuccessful");
            }
          })
        );
      }
    });
  }

  GoBackToCompScreen() {
    this._router.navigate(['setup/implement-component/' + this.selectedImplement]);
  }

  isFirstComponentInList(id, CompTypeId) {
    if (this.observationPoints.find(f => f.Id == id && f.ComponentTypeId == CompTypeId).ComponentTypeSortOrder == 1) {
      return false;
    }
    return true;
  }

  isLastComponentInList(id, CompTypeId) {
    let getallComp = this.observationPoints.filter(f => f.ComponentTypeId == CompTypeId);
    if (getallComp.length > 0) {
      if (getallComp.find(x => x.Id == id).ComponentTypeSortOrder == getallComp.length) {
        return false;
      }
    }
    return true;
  }

  recalculateSortOrder(id, isDown) {
    console.log("id: ", id, isDown)
    console.log("this.observationPoints before sort: ", this.observationPoints);
    for (var i = 0; i < this.observationPoints.length; i++) {
      // Not the entry that was clicked upon.
      if (this.observationPoints[i].Id != id) {
        continue;
      }
      // Found the item that was selected.
      else {
        // First item and sort position decreased.
        if ((i == 0) && !isDown) {
          // DO NOTHING
          //this.observationPoints[i].SortOrder = 0;
        }
        // Last item and sort position increased.
        else if ((i == this.observationPoints.length - 1) && isDown) {
          // DO NOTHING
          //this.observationPoints[i].SortOrder = this.observationPoints.length - 1;
        }
        // Increase sort position
        else if ((i >= 0) && isDown && (i < this.observationPoints.length - 1)) {
          var pos = this.observationPoints[i + 1].SortOrder;
          this.observationPoints[i + 1].SortOrder = this.observationPoints[i].SortOrder;
          this.observationPoints[i].SortOrder = pos;
          var CompTypePos = this.observationPoints[i + 1].ComponentTypeSortOrder;
          this.observationPoints[i + 1].ComponentTypeSortOrder = this.observationPoints[i].ComponentTypeSortOrder;
          this.observationPoints[i].ComponentTypeSortOrder = CompTypePos;
          var _upPoint = this.observationPoints[i + 1];
          this.observationPoints[i + 1] = this.observationPoints[i];
          this.observationPoints[i] = _upPoint;
          break;
        }
        // Decrease sort position
        else if ((i < this.observationPoints.length) && !isDown && (i > 0)) {
          var pos = this.observationPoints[i - 1].SortOrder;
          this.observationPoints[i - 1].SortOrder = this.observationPoints[i].SortOrder;
          this.observationPoints[i].SortOrder = pos;
          var CompTypePos = this.observationPoints[i - 1].ComponentTypeSortOrder;
          this.observationPoints[i - 1].ComponentTypeSortOrder = this.observationPoints[i].ComponentTypeSortOrder;
          this.observationPoints[i].ComponentTypeSortOrder = CompTypePos;
          var _downPoint = this.observationPoints[i - 1];
          this.observationPoints[i - 1] = this.observationPoints[i];
          this.observationPoints[i] = _downPoint;
          break;
        }
      }
    }

    //this.observationPoints.sort((s, t) => {
    //    if (s.SortOrder > t.SortOrder) {
    //        return 1;
    //    }

    //    if (s.SortOrder < t.SortOrder) {
    //        return -1;
    //    }

    //    return 0;
    //});
    console.log("this.observationPoints after sort: ", this.observationPoints);
    this.onObservationNameFilterChange();
  }

  initialiseSortOrder() {
    for (var i = 0; i < this.observationPoints.length; i++) {
      this.observationPoints[i].SortOrder = i;
    }
  }

  InspectionTypeList: componentListsVM[]
  getInspectionTypeList() {
    this._implementService.getInspectionTypeList().subscribe(res => {
      this.InspectionTypeList = res

    })
  }


  //deleteImage(imagedata, val) {

  //  this._implementService.deleteSchematic(imagedata).subscribe(res => {
  //    if (res) { this.toastr.success("Deleted successfully"); }
  //    this.loadImplementSchematics()
  //  })


  //}

  deleteimage(id, isNew, OBSCount) {
    if (OBSCount == 0) {
      const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
        width: '400px',
        data: {
          title: 'Delete Schematic',
          message: "This schematic will be permanently deleted. Do you want to continue?"
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result?.confirmed) {
          if (isNew) {
            var index = this.returnIndexOfItem(id, isNew);
            if (index >= 0) {
              this.schematicList.splice(index, 1);
            }
          } else {
            this._implementService.DeleteImplementSchematicImage(id, this.selectedImplement).subscribe(r => {
              if (r) {
                var index = this.returnIndexOfItem(id, isNew);
                if (index >= 0) {
                  this.schematicList.splice(index, 1);
                  this.loadImplementSchematics();
                }
              } else {
                this.toastr.error("Unable to delete schematic!");
              }
            });
          }
        }
      });
    }
    if (OBSCount > 0) {
      this.toastr.error('This schematic currently has Observation points allocated!');
    }
  }


  // onSelectPhoto(event: any, ImageID) {
  //   if (event.target.files && event.target.files[0]) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]);
  //     reader.onload = (event: any) => {
  //       const imageUrl = (event.target["result"]);
  //       //resize photo
  //       this.compressImage(imageUrl).then((res: string) => {
  //         // console.log("imageUrl", res)
  //         if (res) {
  //           //console.log('res', res)

  //           //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
  //           this.ReplacePhoto(res.split(',')[1], ImageID);
  //         }
  //       })
  //       //this.uploadPhoto(event.target.result.split(',')[1]);
  //     };
  //   }
  // }



// onSelectPhoto(event: any, ImageID: any) {
//   if (event.target.files && event.target.files[0]) {
//     let file = event.target.files[0];
//     const isHeic =
//       file.type === "image/heic" ||
//       file.name.toLowerCase().endsWith(".heic");
//     const processFile = (f: File) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(f);
//       reader.onload = (e: any) => {
//         const imageUrl = e.target.result;
//         this.compressImage(imageUrl).then((res: string) => {
//           if (res) {
//             this.ReplacePhoto(res.split(',')[1], ImageID);
//           }
//         });
//       };
//     };
//     if (isHeic) {
//       (heic2any as any).default({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.8
//       })
//       .then((result: any) => {
//         const convertedBlob = Array.isArray(result) ? result[0] : result;
//         const convertedFile = new File([convertedBlob], "converted.jpg", {
//           type: "image/jpeg"
//         });
//         processFile(convertedFile);
//       })
//       .catch((err: any) => {
//         console.error("HEIC conversion failed", err);
//         this.toastr.error("Failed to process HEIC image. Please try a different image.");
//       });
//     } else {
//       processFile(file);
//     }
//     event.target.value = null;
//   }
// }

async onSelectPhoto(event: any, ImageID: any): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const imageUrl = e.target.result;

      this.compressImage(imageUrl)
        .then((res: string) => {

          if (res) {
            this.ReplacePhoto(res.split(',')[1], ImageID);
          }

        })
        .catch(err => {
          console.error(err);
        });

    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this.toastr.error(
      "Failed to process HEIC image. Please try a different image."
    );

  }

  event.target.value = null;

}

  ReplacePhoto(newPhoto: string, ImageID) {
    var params = new SchematicDataVM()
    params.Data = newPhoto
    params.Id = ImageID
    console.log(ImageID)
    console.log(newPhoto)

    this._implementService.ReplaceSchematic(params).subscribe(res => {
      if (res) { this.toastr.success("Updated successfully"); }
      this.loadImplementSchematics()
    })

  }
  onComponentChange(event: any, obserationID) {
    console.log('Event:', event.value);
    this.newComponentId = event.value;
    this.editComponentForObservation(obserationID);
  }
  editComponentForObservation(obserationID) {
    const updateData = { ObservationPointId: obserationID, ComponentId: this.newComponentId };
    console.log(updateData);
    this._implementService.UpdateComponentsForObservationPoints(updateData).subscribe(res => {
      if (res == true) {
        this.loadObservationPointsForImplement();
        this.toastr.success("Updated successfully");
      } else {
        this.toastr.error("Save Unsuccessful");
      }
    });
  }


  EditObservatinPOint(obserationID, imgOrSchematic) {
    if (imgOrSchematic == 1) {
      this.draggableSchematicTitle = "Implement Image";
    } else if (imgOrSchematic == 2) {
      this.draggableSchematicTitle = "Schematic";
    }
    this._implementService.GetSchematicDataForEditObsevationPoint(obserationID).subscribe((r: any) => {
      if (r.length > 0) {

        this.selectedSchematicEdit = r[0];

        this.FilteredschematicList = this.schematicList;

        this.FilteredschematicList = this.FilteredschematicList.filter(x => x.Id == this.selectedSchematicEdit.Id);
        const addSectionDialog = this.dialog.open(SchemanticOpPopupEditComponent, {

          data: {
            schematic: this.selectedSchematicEdit,
            currentStep: 2,
            mouseoverOPId: r[0].Id,
            title: this.draggableSchematicTitle,
            FilteredschematicList: this.FilteredschematicList,
            // Added these 2 properties to pass to the dialog for TT-9461
            ImplementId: this.selectedImplement,
            ComponentId: this.observationPoints.find(x => x.Id == obserationID).ComponentId,
            ObservationId: obserationID
          }
        });
        addSectionDialog.afterClosed().subscribe(details => {
          if (details) {
            // this.loadImplementSchematics();
            this.loadObservationPointsForImplement();
          }
        });
      }

    });


  }
  //to get all the components TT-9461
  getAllComponents() {
    this._implementService.GetAllComponents(this.selectedImplement).subscribe(res => {
      this.getComponents = res;
      console.log("this.componentList", this.getComponents)
    })
  }

  EdiEqImage(img: string) {

    console.log(img);
    let viewPhotoModalRef = this.dialog.open(ViewPhotoComponent, {
      data: {
        ObsPointType: 'obspoint_image',
        ObsPointId: this.observationListFiltered.filter(x => x.Id == this.mouseoverOPId)[0].Id,
        ObsPointImg: img
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
      if (reloadPhoto)
        this.loadObservationPointsForImplement();
    });

  }

  openPopup(id: number, qDesc: string) {
    this.selectedId = id;
    this.selectedQDesc = qDesc;
    this.showPopup = true;
    this.selectedQImage = this.observationListFiltered.find(x => x.Id == this.selectedId).QuestionImagePath;
  }

  closePopup() {
    this.showPopup = false;
    this.selectedId = null;
    this.selectedQDesc = '';
    this.loadObservationPointsForImplement();
  }


  saveUpdate() {
    const ModelImage_fromPC = this.selectedQImage?.split(',')[1] ?? null;
    this.showPopup = false;
    const params: UpdateQuestion = {
      obsPointId: this.selectedId,
      obsQuestion: this.selectedQDesc,
      obsQuestionImg: ModelImage_fromPC,
    };
    this._implementService.UpdateQuestionInstructionsForObservationPoints(params).subscribe(res => {
      if (res) {
        this.toastr.success("Updated successfully");
        this.loadObservationPointsForImplement();
      } else {
        this.toastr.error("Save Unsuccessful");
      }
    });
  }

  getImageUrl(image: string): any {
    if (!image) return null;

    const isDataUrl = image.startsWith('data:image');
    return isDataUrl ? image : this._sanitizer.bypassSecurityTrustUrl(`data:image/png;base64,${image}`);
  }

  deleteQuestionInstruction(obsId: number) {
    const params: DeleteQuestion = {
      obsPointId: obsId,
      deleteInstruction: true
    };

    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        message: 'Are you sure you want to delete this observation point instruction?',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this._implementService.DeleteQuestionInstructionsForObservationPoints(params).subscribe(res => {
          if (res) {
            this.toastr.success("Deleted successfully");
            this.selectedQDesc = '';
            this.loadObservationPointsForImplement();
          } else {
            this.toastr.error("Delete Unsuccessful");
          }
        });
      }
    });
  }

  openSchematicAndObservationPointDetailsWindow(schematic: SchematicDataVM) {
    let arr_ = [];
    this._implementService.ReturnGETSchematicComponents(this.selectedImplement, schematic.Id).subscribe(result => {
      console.log("this._implementId, schematic.Id", this.selectedImplement, schematic.Id);
      var componentList = result
      schematic.ObservationPoints.map(x => {
        var neModl = new ObservationPointVM();
        neModl.ObservationPointId = x.Id;
        neModl.ObservationPointPosX = x.PositionX;
        neModl.ObservationPointPosY = x.PositionY;
        neModl.EndObservationPointPosX = x.EndPositionX == 0 ? null : x.EndPositionX;
        neModl.EndObservationPointPosY = x.EndPositionY == 0 ? null : x.EndPositionY;
        neModl.isCrackFixed = x.IsCrackFixed;
        neModl.ObservationPointName = x.Name;
        neModl.observationPointTypeId = x.ObPointTypeId;
        neModl.WornPct = x.WornPct;
        neModl.InspectionDate = x.InspectionDate;
        neModl.pointLedgend = 3;
        neModl.CrackStatusId = x.CrackStatusId;
        neModl.ColorCode = x.ColorCode;
        arr_.push(neModl)
      });
      const addSectionDialog = this.dialog.open(AddCrackObsPointDialogComponent, {
        width: '1300px',
        // height: '1075px',
        disableClose: true,
        data: {
          obsDetails: arr_,
          schematic: schematic.Data,
          componentList: componentList,
          schematicId: schematic.Id,
          IsGETInspection: true,
          //inspectionDate: this.implementToBeInspected.InspectionDate,
          //implementInspectionId: this.implementToBeInspected.ImplementInspectionId,
          isGlobalImg: true,
          implementId: this.selectedImplement,
          TypeID: 1,
          disabledCrackOption: true
        }
      });
      addSectionDialog.afterClosed().subscribe(ObsID => {
        if (ObsID > 0) {
          //console.log("details", ObsID)

          //this._inspectionService.recordComponentInspectionForObsPoint(ObsID, this.implementInspectionID).subscribe(res => {
          //        //console.log(res)
          //        //this.updateObs.emit(true);
          //        //this.loadImplementDetails();
          //})
        } else {

        }
      });
    });
  }

  getFilteredComponents(componentTypeId: number) {

    if (!componentTypeId) {
      return this.getComponents;
    }

    return this.getComponents.filter(c =>
      c.ComponentTypeId === componentTypeId
    );
  }

  openHideConfirmationBox(schematicId: number, schematicsName: string, IsHidden: boolean) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: !IsHidden ? 'Hide Schematic' : 'Unhide Schematic',
        message: `Are you sure you want to ${!IsHidden ? 'hide' : 'unhide'} this schematic?\n\n${schematicsName}`
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this._implementService.hideSchematic(this.selectedImplement, schematicId, !IsHidden).subscribe((r: any) => {
          let json_ = JSON.parse(r)
          if (r && r.includes("Cannot")) {
            console.log('r', r)
            this.toastr.error(r);
            //window.location.reload();
          } else if (r) {
            this.toastr.success(r);
            window.location.reload();
          } else {
            this.toastr.error("There is an error while ${!IsHidden ? 'hiding' : 'unhiding'} this schematic.");
          }
        })
      }
    });
  }



}



/////////////////
// File Reader //
/////////////////
export interface FileReaderEventTarget extends EventTarget {
  result: string;
}

export interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}


